import type {
  DemoDataResetFormDefaultProfile,
  DemoDataResetResponse,
} from "../../../../../../../../../../../../../../../api/kehrblatt/demo-data"

export type DemoResetStepId = "admin" | "employee" | "reset"
export type DemoResetProfileId = "admin" | "employee"

export type DemoResetProfileDraft = {
  accessEmail: string
  password: string
  contactEmail: string
  contactMobile: string
  passwordReusable: boolean
  reuseUserId: string | null
}

export type DemoResetProfileOutput = {
  accessEmail: string
  password: string | null
  contactEmail: string
  contactMobile: string
  reuseUserId: string | null
  passwordMode: "replace" | "reuse"
}

export type DemoResetOutput = {
  result: DemoDataResetResponse
  downloadedFiles: ["admin", "employee"]
}

export type DemoResetWorkflowOutputs = {
  admin?: DemoResetProfileOutput
  employee?: DemoResetProfileOutput
  reset?: DemoResetOutput
}

export type DemoResetWorkflowEvent =
  | { type: "profile_saved"; profile: DemoResetProfileId; output: DemoResetProfileOutput }
  | { type: "profile_edit_requested"; profile: DemoResetProfileId }
  | { type: "job_started" }
  | { type: "street_lists_downloaded"; result: DemoDataResetResponse }

export type DemoResetRunPhase =
  | "ready"
  | "enqueueing"
  | "running"
  | "status_unavailable"
  | "succeeded_waiting_download"
  | "failed"
  | "downloaded"

export const profileDraftFromDefault = (
  profile: DemoDataResetFormDefaultProfile,
): DemoResetProfileDraft => ({
  accessEmail: profile.access_email,
  password: "",
  contactEmail: profile.contact_email,
  contactMobile: profile.contact_mobile,
  passwordReusable: profile.password_reusable,
  reuseUserId: profile.reuse_user_id,
})

export const profileDraftFromOutput = (
  output: DemoResetProfileOutput,
  fallback: DemoResetProfileDraft,
): DemoResetProfileDraft => ({
  accessEmail: output.accessEmail,
  password: output.password ?? "",
  contactEmail: output.contactEmail,
  contactMobile: output.contactMobile,
  passwordReusable: output.passwordMode === "reuse" && Boolean(output.reuseUserId),
  reuseUserId: output.reuseUserId ?? fallback.reuseUserId,
})
